
document.addEventListener('DOMContentLoaded', () => {
  const initTabs = (root) => {
    const tabContainers = (root || document).querySelectorAll('[data-product-tabs]');

    tabContainers.forEach(container => {
      const tabs = container.querySelectorAll('.ec-product-tabs__tab');
      const panels = container.querySelectorAll('.ec-product-tabs__panel');

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const idx = tab.dataset.tabIndex;

          tabs.forEach(t => {
            const active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          panels.forEach(p => {
            if (p.dataset.panelIndex === idx) p.removeAttribute('hidden');
            else p.setAttribute('hidden', '');
          });

          window.dispatchEvent(new Event('resize'));
        });
      });
    });
  };

  initTabs();

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => initTabs(e.target));
  }
});
